import { createApp as create, App, Component } from "vue";

export type StarterCallback = (vueInstance: App) => void;

export const createApp = (component: Component) => {
  const app: App = create(component);

  const mount = (domSelector: string | Element) => {
    app.mount(domSelector);
    return {
      app,
    };
  };

  const next = (callback: StarterCallback) => {
    callback(app);
    return {
      app,
      next,
      mount,
    };
  };

  const use = (callback: StarterCallback) => {
    callback(app);
    return {
      app,
      use,
      next,
      mount,
    };
  };

  return {
    app,
    use,
  };
};
